import React from "react";
import { motion } from "framer-motion";
import { AlertTriangleIcon, CheckIcon, LoaderIcon } from "lucide-react";
import { CONTACT } from "../../data/site";
import type { FormStatus } from "../../hooks/useFormStatus";
export function SubmitButton({
  status,
  children
}: {
  status: FormStatus;
  children: React.ReactNode;
}) {
  return <button type="submit" disabled={status === "sending"} className="inline-flex min-h-[54px] items-center justify-center gap-2 rounded-full bg-accent px-8 text-[16px] font-medium text-white transition-[background-color,transform] duration-150 ease-out hover:bg-accent-bright active:scale-[0.98] disabled:opacity-70" data-id="element-121" data-mp="3jg9m7qlomozz">
      {status === "sending" ? <><LoaderIcon className="h-4 w-4 animate-spin" data-id="element-122" data-mp="30i5nlq3f88cf" /> Sending…</> : children}
    </button>;
}
export function FormError() {
  return <p role="alert" className="flex items-start gap-3 rounded-xl border border-red-400/30 bg-red-400/10 p-4 text-[15px] text-red-200" data-id="element-123" data-mp="2329o8l6ed9fd">
      <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0" data-id="element-124" data-mp="1ubrutplji0b6" />
      <span data-id="element-125" data-mp="1ub016kbi6cnj">
        Something went wrong sending your message. Please try again, or email{" "}
        <a href={`mailto:${CONTACT.email}`} className="underline" data-id="element-126" data-mp="1pdgo3nqjk5x6">{CONTACT.email}</a> directly.
      </span>
    </p>;
}
type SuccessProps = {
  title: string;
  text: string;
  action?: React.ReactNode;
};
export function FormSuccess({
  title,
  text,
  action
}: SuccessProps) {
  return <motion.div role="status" initial={{
    opacity: 0,
    scale: 0.97
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }} className="rounded-[clamp(1rem,1.5vw,1.75rem)] border border-accent/50 bg-ink-2 p-[clamp(1.5rem,3vw,3.5rem)]" data-id="element-127" data-mp="1bm1r2czsu474">
      <span className="grid h-12 w-12 place-items-center rounded-full bg-accent" data-id="element-128" data-mp="wpkhnrb66zn7"><CheckIcon className="h-6 w-6 text-white" data-id="element-129" data-mp="2w1dftr9p2b1i" /></span>
      <h2 className="t-h3 mt-6" data-id="element-130" data-mp="2vyrbe0i3obni">{title}</h2>
      <p className="t-body mt-3 max-w-[52ch] text-muted" data-id="element-131" data-mp="2r33ndofctojl">{text}</p>
      {action && <div className="mt-8" data-id="element-132" data-mp="pccwh4yvmxjw">{action}</div>}
    </motion.div>;
}